/**
 * Cookie utility functions for managing authentication cookies
 * Supports cross-subdomain cookie sharing for production (.flowlabs.live)
 */

/**
 * Set authentication cookie with appropriate domain settings
 * @param token - The authentication token to store
 */
export function setAuthCookie(token: string): void {
    const hostname = window.location.hostname;
    const isProduction = hostname.includes('flowlabs.live');

    // Cookie settings
    const maxAge = 30 * 24 * 60 * 60; // 30 days in seconds
    const secure = isProduction; // Only use secure flag in production (HTTPS)
    const sameSite = 'Lax'; // Allow cross-subdomain access

    // Build cookie string
    let cookieString = `authToken=${token}; path=/; max-age=${maxAge}; SameSite=${sameSite}`;

    // Add domain for production to enable cross-subdomain sharing
    if (isProduction) {
        cookieString += `; domain=.flowlabs.live`;
    }

    // Add secure flag for production
    if (secure) {
        cookieString += `; Secure`;
    }

    document.cookie = cookieString;
}

/**
 * Get authentication token from cookie
 * @returns The auth token if found, null otherwise
 */
export function getAuthCookie(): string | null {
    const cookies = document.cookie.split(';');

    for (const cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === 'authToken') {
            return value;
        }
    }

    return null;
}

/**
 * Remove authentication cookie
 */
export function removeAuthCookie(): void {
    const hostname = window.location.hostname;
    const isProduction = hostname.includes('flowlabs.live');

    // Set cookie with past expiration date to delete it
    let cookieString = 'authToken=; path=/; max-age=0';

    // Add domain for production
    if (isProduction) {
        cookieString += '; domain=.flowlabs.live';
    }

    document.cookie = cookieString;
}
